import { ApiInstance } from "../instance"

import { type ApiPostPromocodeActivate } from "./promocodes.types"

export class PromocodesApi extends ApiInstance {
  private routes = {
    activate: "/v1/promocodes/activate",
  }

  readonly queries = {
    activate: ["promocode-activate"],
  }

  activate = (params: ApiPostPromocodeActivate.RequestParams) =>
    this.instance.post<ApiPostPromocodeActivate.Response>(
      this.routes.activate,
      params
    )
}

export const promocodesApi = new PromocodesApi()
